//const api_url = 'http://localhost/ngps_rest_api/';
//const api_url = 'http://localhost/api_ngps/api/';
const api_url = 'https://htcserp.com/api_ngps/api/';
export default api_url;